"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function useDetectClickLocation(_ref) {
  var additionalOutsideTest = _ref.additionalOutsideTest,
      clickedInside = _ref.clickedInside,
      clickedOutside = _ref.clickedOutside,
      ref = _ref.ref;
  (0, _react.useEffect)(function () {
    function handleClick(event) {
      if (ref.current) {
        if (!ref.current.contains(event.target) && (!additionalOutsideTest || additionalOutsideTest(event))) {
          clickedOutside && clickedOutside();
        } else {
          clickedInside && clickedInside();
        }
      }
    }

    document.addEventListener('mousedown', handleClick);
    return function () {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [ref]);
}

var DetectClickLocation = function DetectClickLocation(props) {
  var detectorRef = (0, _react.useRef)(null);
  useDetectClickLocation({
    additionalOutsideTest: props.additionalOutsideTest,
    clickedInside: props.clickedInside,
    clickedOutside: props.clickedOutside,
    ref: detectorRef
  });
  return _react.default.createElement("div", {
    className: props.className,
    ref: detectorRef
  }, props.children);
};

DetectClickLocation.propTypes = {
  additionalOutsideTest: _propTypes.default.func,
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  clickedInside: _propTypes.default.func,
  clickedOutside: _propTypes.default.func
};
var _default = DetectClickLocation;
exports.default = _default;